import * as Unicons from '@iconscout/react-unicons';
import { Button } from 'antd';
import {
  IAcaAulaDTO,
  IFeedbackDTO,
  ITopicoAulaDTO,
} from '../../models/happy-code-api.model';
import useModalClassificacao from './use-modal-classificacao';
import { TFunction } from 'i18next';

interface ModalClassificacaoProps {
  open: boolean;
  onClose: () => void;
  feedback: IFeedbackDTO;
  topico: ITopicoAulaDTO;
  proximaAula: IAcaAulaDTO;
  t: TFunction<"trilhas", undefined>
}

export const ModalClassificacao = ({
  open,
  onClose,
  feedback,
  proximaAula,
  t
}: ModalClassificacaoProps) => {
  const { saveFeedback } = useModalClassificacao({
    feedback,
    proximaAula,
    onClose,
    t
  });

  const buttonPrimaryText = proximaAula ? t('trilhas:finishLesson') : t('trilhas:finish');

  if (!open) return null;

  return (
    <div className="d-flex-row j-center-a-center modal-container">
      <div className="d-flex-column j-start-a-center modal">
        <div className="d-flex-row j-center-a-center circle mb-10">
          <Unicons.UilCheck color="var(--check)" size={80} />
        </div>
        <h1 className="mb-10">
          {t("trilhas:feedbackModal.thankYouTitle")}
          <br />
          {t("trilhas:feedbackModal.thankYouDescription")}
        </h1>
        <div className="line"></div>
        <div className="d-flex-row button-box w-100">
          <Button onClick={onClose} className="button-second mr-15">
            {t("trilhas:feedbackModal.returnToCourse")}
          </Button>
          <Button onClick={saveFeedback} className="button-primary">
            {buttonPrimaryText}
            <Unicons.UilArrowRight size={24} color="var(--white-color)" />
          </Button>
        </div>
      </div>
    </div>
  );
};
